import {enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';


import {environment} from './environments/environment';
import {AppErrorHandler} from './app/@core/app-error-handler';
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {HasuraHttp, K3sHasura, SwarmHasura} from './app/@core/hasura-client';
import {SecureHttp} from './app/@core/secure-http-client';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app/app-routing.module';
import {FormsModule} from '@angular/forms';
import {provideAnimations} from '@angular/platform-browser/animations';
import {AppComponent} from './app/app.component';
import { OrdsClient } from './app/@core/ords-client';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),importProvidersFrom(BrowserModule, AppRoutingModule, FormsModule),
    {
      provide: ErrorHandler,
      useClass: AppErrorHandler
    },
    {provide: NZ_I18N, useValue: en_US},
    {provide: SwarmHasura},
    {provide: HasuraHttp, useExisting: SwarmHasura},
    {provide: K3sHasura},
    SecureHttp,
    OrdsClient,
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations()
  ]
})
  .catch(err => console.error(err));
